import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { OrganizationsService } from 'src/app/Services/organizations.service';
import { Busyable } from 'src/app/shared/editors/busyable';

@Component({
    selector: 'app-hotelreservation',
    templateUrl: './hotelreservation.component.html',
    styleUrls: ['./hotelreservation.component.scss'],
    standalone: false
})
export class HotelreservationComponent extends Busyable implements OnInit {
  public ModelId: any;
  public Model: any;
  public WorkflowActions: any = null;
  public orgService: OrganizationsService;

  constructor(private apiService: ApiServiceBase, private parentRoute: ActivatedRoute, organizationService: OrganizationsService) {
    super();
    this.orgService = organizationService;
  }

  ngOnInit(): void {
    this.Loading();
    this.parentRoute.params.subscribe(params => {
      this.ModelId = params['id'];
      this.LoadModelAndActionsAsync();
    });
  }

  private async LoadModelAndActionsAsync(): Promise<void> {
    try {
      if (!this.ModelId) {
        this.Model = null;
        this.WorkflowActions = null;
        return;
      }

      this.Model = await this.apiService.Get<any>("permits/hotelreservations/" + this.ModelId);

      try {
        this.WorkflowActions = await this.apiService.Get<any>(`permits/${this.ModelId}/workflow/actions`);
      } catch (err) {
        console.error('Error loading hotel reservation workflow actions:', err);
        this.WorkflowActions = null;
      }
    } catch (err) {
      console.error('Error loading hotel reservation:', err);
      this.Model = null;
      this.WorkflowActions = null;
    } finally {
      this.StopLoading();
    }
  }

  public ExecutePermitTransition(transitionId: number) {
    if (!this.ModelId) return;
    this.Loading();

    this.apiService.Post<boolean>(`permits/${this.ModelId}/workflow/actions`, {
      Type: 1, // Transition
      Target: 1, // Permit
      Id: transitionId,
      Parameters: null
    }).then(_ => {
      this.apiService.Get<any>("permits/hotelreservations/" + this.ModelId).then(result => {
        this.Model = result;
        this.apiService.Get<any>(`permits/${this.ModelId}/workflow/actions`).then(actions => {
          this.WorkflowActions = actions;
          this.StopLoading();
        }, _ => {
          this.WorkflowActions = null;
          this.StopLoading();
        });
      }, _ => {
        this.StopLoading();
      });
    }, _ => {
      this.StopLoading();
    });
  }
}


